import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BackgroundColorContainer, Heading } from '../../atoms';
import {
  ContentContainer,
  ContactInfo,
  ContactMethod,
  Icon,
  Heading1,
  PageHeadings,
  StyledGladly,
} from './styles.js';
import { GLADLY_CONFIG, GLADLY_INIT_SCRIPT_ID, loadGladly } from './config';

export const Gladly = ({
  contactHeading,
  contactMethods,
  heading1,
  heading2,
}) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && !loaded) {
      window.gladlyHCConfig = GLADLY_CONFIG;
      loadGladly(() => {
        setLoaded(true);
      });

      return function cleanup() {
        // Gladly loads when one of these injected scripts invokes.
        // Remove scripts to allow successful page load if user leaves and comes back.
        document.getElementById(GLADLY_INIT_SCRIPT_ID).remove();
        Array.from(document.getElementsByTagName('script'))
          .filter(scriptTag => scriptTag.src.match(/cdn\.gladly\.com/))
          .forEach(element => element.remove());
        window.gladlyHCLoaded = false;
      };
    }
  }, [loaded]);

  return (
    <BackgroundColorContainer bgColor="background.base">
      <ContentContainer>
        <PageHeadings>
          <Heading1>{heading1}</Heading1>
          <Heading
            headingText={heading2}
            headingLevel="h2"
            typography="heading1"
          />
        </PageHeadings>
        <StyledGladly id="gladly-help-center" />
        <ContactInfo>
          <Heading
            headingText={contactHeading}
            headingLevel="h4"
            typography="heading4"
          />
          {contactMethods.map((contact, i) => (
            <ContactMethod href={contact.path} key={i}>
              <Icon src={contact.icon.src} alt={contact.icon.alt} />
              {contact.text}
            </ContactMethod>
          ))}
        </ContactInfo>
      </ContentContainer>
    </BackgroundColorContainer>
  );
};

Gladly.displayName = 'Gladly';
Gladly.propTypes = {
  heading1: PropTypes.string.isRequired,
  heading2: PropTypes.string.isRequired,
  contactHeading: PropTypes.string.isRequired,
  contactMethods: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      icon: PropTypes.shape({
        alt: PropTypes.string.isRequired,
        src: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
          .isRequired,
      }).isRequired,
    }).isRequired,
  ),
};
